export class ApiError extends Error {
  public statusCode: number;
  public details: Record<string, any>;

  /**
   * @constructor
   *
   * @param message
   * @param name
   * @param statusCode
   * @param details
   */
  constructor(message: string, name?: string, statusCode?: number, details?: Record<string, any>) {
    super(message);

    this.name = name ?? 'ApiError';
    this.statusCode = statusCode ?? 500;
    this.details = details ?? {};
  }
}
